import { useEffect, useState } from "react";
import { shouldShowPostRefresh } from "./LightningStrike";

const PostRefreshFadeIn = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (shouldShowPostRefresh()) {
      setShow(true);
      const t = setTimeout(() => setShow(false), 450);
      return () => clearTimeout(t);
    }
  }, []);

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-[9998] pointer-events-none animate-post-refresh-fadein"
      style={{
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)",
        background: "hsl(var(--background) / 0.5)",
      }}
      aria-hidden="true"
    />
  );
};

export default PostRefreshFadeIn;
